// tslint:disable:insecure-random
const { sqrt, pow, floor, PI, max, sin, cos, random: randomFloat } = Math;
// Animate out quickly
function easeOutCirc(pos) {
    return sqrt(1 - pow(pos - 1, 2));
}
export function easeInSin(pos) {
    return -Math.cos(pos * (Math.PI / 2)) + 1;
}
function randomizeNumber(a, b) {
    return () => {
        return a + (b - a) * randomFloat();
    };
}
export function randomizeNumberPair(x, y) {
    const randX = randomizeNumber(...x);
    const randY = randomizeNumber(...y);
    return () => [randX(), randY()];
}
function randomizeArray(a) {
    const rand = randomizeNumber(0, a.length - 1);
    return () => {
        const i = floor(rand());
        return a[i];
    };
}
export const random = {
    number: randomizeNumber,
    numberPair: randomizeNumberPair,
    arrayItem: randomizeArray,
};
const randomTheta = randomizeNumber(PI, PI * 2);
const randomFifty = randomizeNumber(-0.5, 0.5);
let Particle = /** @class */ (() => {
    class Particle {
        constructor() {
            this.age = 0;
            this.isDead = false;
            this.theta = 0;
            this.color = "black";
            this.originalRadius = 0;
            this.location = [0, 0];
            this.velocity = [0, 0];
            this.acceleration = [0, 0];
            this.wander = 0;
            this.startDyingAt = 0;
            this.maxAge = 0;
            this.friction = 0;
            this.spawnUntil = 0;
        }
        static get(color, originalRadius, location, velocity, acceleration, wander, startDyingAt, maxAge, friction, spawnUntil) {
            let p = Particle.pool.pop();
            p = p || new Particle();
            return p.clear(color, originalRadius, location, velocity, acceleration, wander, startDyingAt, maxAge, friction, spawnUntil);
        }
        static return(p) {
            Particle.pool.push(p);
        }
        clear(color, originalRadius, location, velocity, acceleration, wander, startDyingAt, maxAge, friction, spawnUntil) {
            this.color = color;
            this.originalRadius = originalRadius;
            this.location = location;
            this.velocity = velocity;
            this.acceleration = acceleration;
            this.wander = wander;
            this.startDyingAt = startDyingAt;
            this.maxAge = maxAge;
            this.friction = friction;
            this.spawnUntil = spawnUntil;
            this.age = 0;
            this.isDead = false;
            this.theta = wander > 0 ? randomTheta() : 0;
            return this;
        }
        kill() {
            this.isDead = true;
        }
        percentInLife() {
            return this.age / this.maxAge;
        }
        get radius() {
            if (this.isNearDead()) {
                const fullRange = 1.0 - this.startDyingAt;
                const alongRange = 1.0 - this.percentInLife();
                const multiplier = alongRange / fullRange;
                return max(0, this.originalRadius * easeOutCirc(multiplier));
            }
            if (this.isSpawning()) {
                const multiplier = this.percentInLife() / this.spawnUntil;
                return max(1, this.originalRadius * easeInSin(multiplier));
            }
            return this.originalRadius;
        }
        set radius(r) {
            if (this.isSpawning() || this.isNearDead()) {
                return;
            }
            this.originalRadius = r;
        }
        isNearDead() {
            return this.percentInLife() >= this.startDyingAt;
        }
        isSpawning() {
            return this.percentInLife() <= this.spawnUntil;
        }
        tick(delta) {
            if (this.age > this.maxAge) {
                this.kill();
            }
            this.age += delta;
            this.location[0] += this.velocity[0] * delta;
            this.location[1] += this.velocity[1] * delta;
            this.velocity[0] += this.acceleration[0] * delta;
            this.velocity[1] += this.acceleration[1] * delta;
            this.velocity[0] *= 1 - this.friction * delta;
            this.velocity[1] *= 1 - this.friction * delta;
            this.theta += randomFifty() * this.wander;
            this.velocity[0] += sin(this.theta) * 0.1;
            this.velocity[1] += cos(this.theta) * 0.1;
        }
    }
    Particle.pool = [];
    return Particle;
})();
export { Particle };
//# sourceMappingURL=Particle.js.map